<template>
  <div class="page-container-v2">
    <page-header
      :title="$t('itemslist_title')"
      :sub-title="$t('itemslist_desc')"
    />
    <div class="item-page-container-v2">
      <div class="item-left-v2">
        <div class="card-v2">
          <div class="items-container-v2">
            <div class="one-item-section">
              <label class="label-row-v2"
                >{{ $t('itemslist_choose_dept') }}<span class="required-span" /></label>
                <div class="content-row-v2">
                  <a-radio-group 
                    v-model:value="medicalDept"
                    class="radio-div"  
                  >
                    <a-radio v-for="(item, i) in deptList" :key="i" :value="item.code">{{ item.name }}</a-radio>
                  </a-radio-group>
                </div>
            </div>
            <div class="one-item-section">
              <label class="label-row-v2"
                >{{ $t('itemslist_table_type') }}
              </label>
              <div class="content-row-v2">
                <a-input
                class="input-text-common" 
                :placeholder="$t('itemslist_type_placeholder')"
                  v-model:value="productType"
                />
              </div>
            </div>
            <div class="one-item-section" v-if="medicalDept==='DENT'">
              <label class="label-row-v2"
                >{{ $t('itemslist_table_brand') }}<span class="required-span"/>
              </label>
              <a-select
                style="width:calc(100% - 150px);"
                v-model:value="itemBrand"
                :placeholder="$t('itemslist_addpage_placeholder_brand')" 
                :options="itemBrandOptions"
                @input="handleInputItemBrand"
                :searchValue="itemBrand"
                show-search
              >
                <template #notFoundContent>
                  {{ $t('noresult_search') }}
                </template>
              </a-select>
            </div>
            <div class="one-item-section">
              <label 
              class="label-row-v2"
                >{{ $t('itemslist_table_itemcode') }}<span class="required-span"/></label>
              <div class="content-row-v2">
                <a-input
                  v-model:value="itemCode" 
                  class="input-text-common" 
                  :placeholder="$t('itemslist_addpage_placeholder_itemcode')" 
                  @input="handleItemCode"
                />
              </div>
            </div>
            <div class="one-item-section">
              <label 
              class="label-row-v2"
                >{{ $t('itemslist_table_itemname') }}<span class="required-span"/></label>
              <div class="content-row-v2">
                <a-input 
                  v-model:value="itemName" 
                  class="input-text-common" 
                  :placeholder="$t('itemslist_addpage_placeholder_itemname')"/>
              </div>
            </div>
            <div class="one-item-section">
              <label 
              class="label-row-v2"
                >{{ $t('itemslist_table_itemspec') }}</label>
              <div class="content-row-v2">
                <a-input 
                class="input-text-common" 
                :placeholder="$t('itemslist_table_itemspec_placeholder')" 
                v-model:value="itemSpec" 
                />
              </div>
            </div>
            <div class="one-item-section">
              <label class="label-row-v2">{{ $t('itemslist_table_itemdesc') }}</label>
              <div class="content-row-v2">
                <a-textarea 
                class="input-textarea-common" 
                :placeholder="$t('itemslist_addpage_placeholder_itemdesc')" 
                v-model:value="description" 
                />
              </div>
            </div>
            <div class="one-item-section">
              <label class="label-row-v2">{{ $t('itemslist_addpage_placeholder_properties') }}</label>
              <div class="property-area d-flex">
                <div
                  v-for="(item, i) in jsonContents"
                  :key="i"
                  class="w-100"
                  style="margin-bottom: 10px; display: flex; align-items: center;"
                >
                  <a-input
                    class="key-input input-text-common" 
                    v-model:value="item.propertyName" 
                    :placeholder="$t('itemslist_addpage_placeholder_key')"
                    required
                  />
                  <a-input
                    class="value-input input-text-common" 
                    :class="jsonContents.length > 0 ? '' : 'value-full-width'"
                    v-model:value="item.propertyValue" 
                    :placeholder="$t('itemslist_addpage_placeholder_value')"
                    required
                  />
                  <a-button v-if="jsonContents.length > 0" 
                    @click="removeItem(i)" 
                    shape="circle"  
                  >
                    <template #icon>
                      <i class="fa-duotone fa-minus"/>
                    </template>
                  </a-button>
                </div>
                <a-button  
                  class="add-prop-btn" 
                  @click="addRow"
                >
                  <template #icon>
                    <i class="fa-solid fa-plus"/> 
                  </template>
                  {{ $t('itemslist_addpage_add_value') }}
                </a-button>
              </div>
            </div>
            <div class="one-item-section">
              <label 
                class="label-row-v2"
                >{{ $t('itemslist_table_unregister') }}
              </label>
              <div class="switch-area">
                <a-switch v-model:checked="unregisterYn" />
                <p class="true-color" id="unregister-text">
                  {{ unregisterYn
                    ? $t('itemslist_addpage_no_register_desc_y')
                    : $t('itemslist_addpage_no_register_desc_n')
                  }}
                </p>
              </div>
            </div>
            <div class="one-item-section">
              <label 
                class="label-row-v2"
                >{{ $t('itemslist_allow_dup') }}
              </label>
              <div class="switch-area">
                <a-switch v-model:checked="duplicateYn" />
                <p class="true-color" id="duplicate-text">
                  {{ duplicateYn
                    ? $t('itemslist_addpage_no_duplicate_desc_y')
                    : $t('itemslist_addpage_no_duplicate_desc_n')
                  }}
                </p>
              </div>
            </div>
            <div class="one-item-section">
              <label 
                class="label-row-v2"
                >{{ $t('itemslist_addpage_certificate_image') }}<span class="required-span"/></label>
              <div class="file-input-wrap">
                <input
                  type="file"
                  accept="image/jpeg, image/png, image/gif"
                  @change="changeLogoImage()"
                  id="fileInput"
                  ref="fileInput"
                />
                <div class="file-relative-wrap">
                  <a-input 
                  type="text" 
                  class="input-text-common file-name-input" 
                  :placeholder="$t('itemslist_addpage_certificate_image_placedholer')"
                  readonly
                  v-model:value="fileName"
                  />
                  <div  v-if="fileName || fileData" class="download-wrap" @click="downloadLogoImage()">
                    <i class="fa-solid fa-down-to-bracket"/>
                  </div>
                  <a-button 
                    class="black no-radius-left no-radius-right img-add-btn"
                    @click="clickFileInput"
                  >
                  {{ $t('itemslist_addpage_certificate_image_add_modify') }}
                  </a-button>
                </div>
                <a-button  @click="deleteImage">
                  {{ $t('itemslist_addpage_certificate_image_delete') }}
                </a-button>
              </div>
            </div>
            <div class="one-item-section" style="margin-bottom: 0px !important;">
              <label class="label-row-v2" />
              <div class="img-desc">
                <ul style="padding-left: 1rem;">
                  <li>
                    {{ $t('itemslist_addpage_certificate_image_instruction_size') }}
                  </li>
                  <li>
                    {{ $t('itemslist_addpage_certificate_image_instruction_ext') }}
                  </li>
                  <li>
                    {{ $t('itemslist_addpage_certificate_image_instruction_file_size') }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="one-item-section">
              <label 
                class="label-row-v2"
                >{{ $t('itemslist_addpage_certificate_bg_color') }}<span class="required-span"/></label>
              <div class="color-picker-wrap">
                <color-picker v-model:pureColor="pureColor" />
                <a-input
                  class="input-text-common" 
                  id="rgbaInput"
                  style="display: none;"
                  v-model:value="pureColor"
                  @input="convertToHex"
                />
                <p class="true-color2">{{ hexValue }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="item-btn-area-v2">
          <a-button
            @click="$router.push('/item')"
            class="certi-cancel-btn"
          >
            <p>{{ $t('common_cancel') }}</p>
          </a-button>
          <a-button
            type="primary"
            @click="uploadImgAndData"
            class="certi-submit-btn"
          >
            <p>{{ $t('itemslist_addpage_modify_item') }}</p>
          </a-button>
        </div>
      </div>
      <div class="col-3 phone-preview-wrap" ref="phone-preview-wrap" style="margin-right: 80px;">
        <div class="island" >
          <img src="@/assets/img/phoneEye.png"  />
        </div>
        <div
          class="col-sm-12 phoneBg"
          :style="
            hexValue.length > 0
              ? 'background-color:' + hexValue
              : 'background-color:#F1F2F3'
          "
        >
          <div class="imgDiv">
            <img
            ref="prevImg"
              id="prevImg" :src="hasImage
              ? certificateImgUrl
              : 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/2678b0f372f4418891e8910214af6637/test-npaas/Brand%253DCertiLife1024.png'
            " 
              
            />
          </div>
          <div class="col-sm-12 phoneText">
            <em />
            <div class="certTitle" :class="{ open: isOpen }">
              <h4>
                {{ itemName.length > 0 ? itemName : 'CERTILIFE' }}
              </h4>
              <p>{{ description }}</p>
              <p>
                {{ $t('itemslist_addpage_additional_desc') }}
              </p>
            </div>
            <button
              class="overflowBtn"
              type="button"
              @click="toggleOverflow"
              :class="{ clicked: isClicked }"
            >
              <img src="@/assets/img/rightGray.png"  />
            </button>
            <div class="cert_info">
              <h4>{{ $t('itemslist_addpage_detail') }}</h4>
              <table>
                <tr>
                  <td class="head">{{ $t('itemslist_addpage_brand') }}</td>
                  <td>{{ brand }}</td>
                </tr>
                <tr v-if="jsonContents.length > 0 && 
                  (jsonContents[0].propertyName || 
                  jsonContents[0].propertyValue)" 
                  v-for="(item, i) in jsonContents">
                  <td class="head">{{ item.propertyName }}</td>
                  <td>{{ item.propertyValue }}</td>
                </tr>
                <tr>
                  <td class="head">{{ $t('itemslist_addpage_surgery_date') }}</td>
                  <td>{{ date }}</td>
                </tr>
                <tr>
                  <td class="head">{{ $t('itemslist_addpage_dept') }}</td>
                  <td>{{ convertMedicalDept(medicalDept) }}</td>
                </tr>
              </table>
            </div>
            <div class="cert_info">
              <h4>{{ $t('itemslist_addpage_history') }}</h4>
              <table>
                <tr>
                  <td class="head">{{ $t('itemslist_addpage_issued_at') }}</td>
                  <td>{{ date }}</td>
                </tr>
                <tr>
                  <td class="head">{{ $t('itemslist_addpage_sent_from') }}</td>
                  <td>{{ $t('itemslist_addpage_issued_self') }}</td>
                </tr>
                <tr>
                  <td class="head">{{ $t('itemslist_addpage_transaction_hash') }}</td>
                  <td>
                    <button type="button" class="hash-btn">
                      <input type="text" value="0x4f2a7d8e...b5123d4887" readonly disabled />
                      <i class="fa-regular fa-copy" />
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfile } from '@/utils/tokenStore';
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';
import { changeBytesToMegabytes, oneBtnDialog, convertYnToBool, boolToYn } from '@/utils/utils';
import { convertMedicalDept } from '@/utils/enums';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { MedicalDept } from '@/utils/enums';
import PageHeader from '@/views/components/PageHeader.vue';
export default {
  name: 'ModifyItem',
  components: { 
    ColorPicker,
    PageHeader,
  },
  computed: {
    date() {
      return dayjs().format('YYYY/MM/DD');
    },
  },
  data() {
    return {
      companyInfo: JSON.parse(getProfile('CompanyInfo')),
      itemId: this.$route.params.itemId,
      brand: '',
      itemDetailData: '',
      medicalDept: '', // 과
      convertMedicalDept: convertMedicalDept,
      productType: '', // 제품분류
      unregisterYn: false, // 무등록 발행
      itemBrand: '', // 제품 명
      itemCode: '', // 품목 코드
      itemName: '', // 품목명
      itemSpec: '', // 품목 스펙
      description: '',
      duplicateYn: false, // 중복 허용
      fileName: '', // 이미지 파일명
      fileData: null, // 실제 파일 정보가 담긴 폼데이터
      certificateImgUrl: '', // objectStorage 상 이미지 url
      hasImage: false,
      background_color: null, // NFT배경색
      deptList: [], // 과 목록
      jsonContents: [
        {
          propertyName: '',
          propertyValue: '',
        },
      ],
      pureColor: 'rgb(255, 255, 255)',
      hexValue: '',
      hasRequested: false,
      isOpen: false,
      isClicked: false,
      itemBrandOptions:[],
    };
  },
  // rgba코드 hex코드로 바꾸기
  watch: {
    pureColor(newValue) {
      this.brand = getProfile('companyManu') ? getProfile('companyManu') : '제조사';
      const rgbaRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/;
      const matches = this.pureColor.match(rgbaRegex);
      if (matches) {
        this.convertToHex();
      }
    },
  },
  // rgba코드 hex코드로 바꾸기
  async mounted() {
    this.convertToHex(); // 초기 Hex 값
    await this.getDeptList();
    this.getItemDetail();
    
    this.itemBrandOptions = await this.getDentItemStepOne()
    this.itemBrandOptions = this.itemBrandOptions.map(i=>{
      return {
        label:i.brand,
        value:i.brand,
      }
    });
  },
  methods: {
    handleInputItemBrand(event){
      this.itemBrand = event.target.value; 
    },
    handleItemCode(event) {
      let inputValue = event.target.value;
      const regex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?]*$/;
      if (!regex.test(inputValue)) {
          event.target.value = inputValue.replace(/[^a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?]/g, '');
      }
    },
    async getItemDetail() {
      try {
        const response = await this.$apiInstance.get(`/items/${this.itemId}`);
        if (response.status === 200 || response.status === 201) {
          const { data } = response;

          this.medicalDept = data.medicalDept; // 과
          this.productType = data.productType; // 제품분류
          this.itemBrand = data.brand; // 제품분류
          this.itemCode = data.itemCode; // 품목 코드
          this.itemName = data.itemName; // 품목명
          if(data.itemSpec) {
            this.itemSpec = data.itemSpec;
          } else {
            this.itemSpec = '';
          }
          if(data.description) this.description = data.description;
          if(data.background_color){
            this.background_color = data.background_color; // NFT배경색
            this.pureColor = data.background_color;
            this.hexValue = data.background_color;
          }

          this.duplicateYn = convertYnToBool(data.duplicateYn);
          this.unregisterYn = convertYnToBool(data.unregisterYn);
          
          let fileName;
          if(data.certificateImgUrl) {
            this.certificateImgUrl = data.certificateImgUrl; // objectStorage 상 이미지 url
            const fileNameArray = data.certificateImgUrl.split('/');
            fileName = fileNameArray[fileNameArray.length - 1];
          }
          this.fileName = fileName;

          if(data.certificateImgUrl) this.hasImage = true;
  
          this.jsonContents = [];
          if (response.data.jsonContents) {
            const jsonObj = JSON.parse(data.jsonContents);
            for (let i = 0; i < jsonObj.length; i++) {
              this.jsonContents.push({
                propertyName: Object.keys(jsonObj[i])[0],
                propertyValue: Object.values(jsonObj[i])[0],
              }); 
            }
          }
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('itemslist_detail_fail_title'), this.$i18n.t('itemslist_detail_fail_content'), false);
        this.$router.push('/item');
      }
    },
        /* 
      
    클릭클릭 제조사 정보 가져오기(치아 선택 시에 바인딩)

      고민: 거의 고정값이므로 페이지 로드 시에 1회만 호출? 치아 선택 마다 호출?

    */
    async getDentItemStepOne() {
      const obj = {};
      obj.manufacturer = this.companyInfo.name;

      let resultCompanies = [];
      try {
        const response = await this.$apiInstance.post(`/items/dent/2`, obj);
        if (response.status === 200 || response.status === 201) {
          if(response.data) resultCompanies = response.data;
        }
      } catch(error) {
        console.log(error);
        await oneBtnDialog('품목 가져오기 실패', '품목 가져오기에 실패했습니다.', false);
      } finally {
        return resultCompanies;
      }
    },
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if (response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('hospitalw_message_get_dept_title'),this.$i18n.t('hospitalw_message_get_dept_content'), false);
      }
    },
    async validateData() {
      let result = true;
      const hexRegex = /^#([0-9a-fA-F]{3}){1,2}$/;

      if(!this.medicalDept) {
        result = false;
        await oneBtnDialog(this.$i18n.t('itemslist_nodept_err_title'), this.$i18n.t('itemslist_nodept_err_content'), false);
        return result;
      } else if (this.medicalDept === MedicalDept.DENT && !this.itemBrand) {
        result = false;
        oneBtnDialog(this.$i18n.t('itemslist_nobrand_err_title'), this.$i18n.t('itemslist_nobrand_err_content'), false);
        return result;
      } else if (!this.itemCode) {
        result = false;
        await oneBtnDialog(this.$i18n.t('itemslist_nocode_err_title'), this.$i18n.t('itemslist_nocode_err_content'), false);
        return result;
      } else if (!this.itemName) {
        result = false;
        await oneBtnDialog(this.$i18n.t('itemslist_noname_err_title'), this.$i18n.t('itemslist_noname_err_content'), false);
        return result;
      } else if (!this.certificateImgUrl && ( !this.fileName || !this.fileData)) {
        result = false;
        await oneBtnDialog(this.$i18n.t('itemslist_noimage_err_title'), this.$i18n.t('itemslist_noimage_err_content'), false);
        return result;
      } else if (this.background_color && !hexRegex.test(this.background_color)) {
        result = false;
        await oneBtnDialog(this.$i18n.t('itemslist_color_err_title'), this.$i18n.t('itemslist_color_err_content'), false);
        return result;
      } 
      return result;
    },
    //////////////////////////////////
    
    // 이미지와 데이터 업로드 및 후처리
    async uploadImgAndData() {
      if (await this.validateData()) {
        if(!this.hasRequested) {
          await this.uploadImage();
          if (this.certificateImgUrl !== '') {
            await this.updateItem();
            await oneBtnDialog(this.$i18n.t('itemslist_modify_done_title'), this.$i18n.t('itemslist_modify_done_content'), false);
            this.$router.push('/item');
          }
        }
      }
    },
    
    // 이미지 오브젝트스토리지에 업로드
    async uploadImage() {
      if (this.fileData) {
        try {
          const response = await this.$apiInstance.post(
            `/object-storages`,
            this.fileData
            );
            if (response.status === 200 || response.status === 201) {
              this.certificateImgUrl = response.data.url;
            }
          } catch (error) {
            console.log(error);
            await oneBtnDialog(this.$i18n.t('itemslist_modify_fail_title'), this.$i18n.t('itemslist_modify_fail_content'), false);
            this.hasRequested = false;
        }
      } else {
      }
    },

    // 데이터 서버에 전송
    async updateItem() {
      const obj = {};
      obj.medicalDept = this.medicalDept;
      if(this.productType) {
        obj.productType = this.productType;
      } else {
        obj.productType = '';
      }

      obj.itemName = this.itemName;
      obj.brand = this.itemBrand;
      obj.itemCode = this.itemCode;
      obj.unregisterYn = boolToYn(this.unregisterYn);
      obj.duplicateYn = boolToYn(this.duplicateYn);
      obj.certificateImgUrl = this.certificateImgUrl;
      if(this.description) {
        obj.description = this.description;
      } else {
        obj.description = '';
      }
      
      if(this.background_color && this.background_color !== '') obj.background_color = this.background_color;

      const newJsonContents = new Array();
      this.jsonContents.forEach((element) => {
        if (element.propertyName && element.propertyValue) {
          const newObject = {};
          newObject[element.propertyName] = element.propertyValue;
          if(!obj.itemSpec){
            obj.itemSpec =element.propertyValue
          }
          newJsonContents.push(newObject);
        }
      });
      if(this.itemSpec) {
        obj.itemSpec = this.itemSpec;
      } else {
        obj.itemSpec = '';
      }
      if (newJsonContents.length > 0) {
        obj.jsonContents = JSON.stringify(newJsonContents);
      } else {
        obj.jsonContents = '';
      }

      try {
        const response = await this.$apiInstance.put(`/items/${this.itemId}`,obj);
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('itemslist_modify_fail_title'), this.$i18n.t('itemslist_modify_fail_content'), false);
        this.hasRequested = false;
      }
    },

    // 속성 줄 추가
    addRow() {
      const propertyObj = {
        propertyName: '',
        propertyValue: '',
      };
      this.jsonContents.push(propertyObj);
    },
    removeItem(index) {
      this.jsonContents.splice(index, 1);
    },
    deleteImage() {
      this.fileData = null;
      this.fileName = '';
      this.certificateImgUrl = '';
      this.hasImage = false;
      this.$refs.prevImg.src = 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/2678b0f372f4418891e8910214af6637/test-npaas/Brand%253DCertiLife1024.png';
    },
    async clickFileInput() {
      const fileInput = this.$refs.fileInput;
      fileInput.click();
    },
    // 파일 형식 valitdate
    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/gif' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert(this.$i18n.t('hospitalw_message_file_type'));
        result = false;
      } else if (changeBytesToMegabytes(file.size) > 100) {
        alert(this.$i18n.t('hospitalw_message_file_size'));
        result = false;
      }

      return result;
    },
    // 로고 이미지 onChange메소드 및 미리보기
    changeLogoImage() {
      const fileInput = this.$refs.fileInput;
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if (validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById('prevImg').src = e.target.result;
          };
          this.hasImage = true;
          reader.readAsDataURL(fileInput.files[0]);
          this.fileName = fileInput.files[0].name;

          const formData = new FormData();
          formData.append('file', fileInput.files[0]);
          this.fileData = formData;
        }
      }
    },
    downloadLogoImage() {
      const fileInput = this.$refs.fileInput;
      const file = fileInput.files[0];
      if (file) {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(file);
        downloadLink.download = file.name;
        downloadLink.click();
      } else {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = this.certificateImgUrl;
        downloadLink.download = this.fileName;
        downloadLink.click();
      }
    },

    // rgba코드 hex코드로 바꾸기
    convertToHex() {
      const rgbaRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/;
      const matches = this.pureColor.match(rgbaRegex);
      if (matches) {
        const r = parseInt(matches[1]);
        const g = parseInt(matches[2]);
        const b = parseInt(matches[3]);
        const a = matches[4] ? parseFloat(matches[4]) : 1;

        const toHex = (dec) => {
          const hex = dec.toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        };
        const hexR = toHex(r);
        const hexG = toHex(g);
        const hexB = toHex(b);
        const hexA = toHex(Math.round(a * 255));
        this.hexValue = `#${hexR}${hexG}${hexB}${hexA}`.substring(0, 7); // 7자리까지만 추출
        this.background_color = this.hexValue;
      } else {
        this.hexValue = ''; // 유효하지 않은 값인 경우에는 빈 문자열로 설정
        this.background_color = '';
      }
    },
    toggleOverflow() {
      this.isOpen = !this.isOpen;
      this.isClicked = !this.isClicked;
    },
  },
};
</script>

<style lang="scss" scoped>
@import  '@/views/items/css/items.scss';

@media screen and (max-width:767px) {
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }

  .file-input-wrap,
  .file-input-wrap .file-relative-wrap,
  .content-wrap-card .inputDiv{
    display: flex;
    flex-direction: column;
  }

  .item-btn-area,
  .content-wrap-card .inputDiv,
  .colorPicker,
  .file-input-wrap,
  .property-area,
  .content-wrap-card .inputDiv .input-textarea-common,
  .content-wrap-card .inputDiv .input-text-common{
    width: 100% !important;
    max-width: none;
  }
}
</style>